import { useTranslation } from 'react-i18next';
import DashboardLayout from '@/components/feature/DashboardLayout';
import OreeMarketView from './components/OreeMarketView';
import TradingRdFrame from './components/TradingRdFrame';

/**
 * Дуальний режим (§6 handoff): стенд із VITE_REDESIGN бачить редизайн, прод —
 * незмінений LegacyTradingOverview. Так злиття гілки не змінює cabinet.*.
 */
function LegacyTradingOverview() {
  const { t } = useTranslation();
  return (
    <DashboardLayout>
      <div className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">{t('trading_overview_title')}</h1>
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t('trading_overview_subtitle')}</div>
      </div>
      <OreeMarketView marketFilter={null} />
    </DashboardLayout>
  );
}

export default function TradingOverviewPage() {
  const { t } = useTranslation();
  const isRd = import.meta.env.VITE_REDESIGN === '1';
  if (!isRd) return <LegacyTradingOverview />;
  return (
    // Заголовок у тілі не дублюємо: назву розділу («Торговий графік»)
    // вже показує топбар. Підмаршрути РДН/ВДР свої підписи лишають —
    // там вони не збігаються з тим, що в шапці.
    <TradingRdFrame
      breadcrumb={[t('nav_trade_schedule')]}
      marketFilter={null}
    />
  );
}
